import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // Show floating CTA after scrolling 300px
      setShowFloatingCTA(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Don't show floating CTA on contact page (already has booking form)
  const isContactPage = location.pathname === '/contact';

  return (
    <div className="min-h-screen bg-brand-cream">
      <Navbar />
      <main className="pt-24">{children}</main>
      <Footer />

      {/* Floating CTA Button */}
      <AnimatePresence>
        {showFloatingCTA && !isContactPage && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ duration: 0.3 }}
            className="fixed bottom-6 right-6 z-50"
          >
            <Link
              to="/contact"
              onClick={() => window.scrollTo(0, 0)}
              data-testid="floating-cta-btn"
              className="flex items-center gap-2 bg-brand-primary hover:bg-brand-medium text-white rounded-full px-6 py-4 font-medium shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <Calendar size={20} />
              <span className="hidden sm:inline">Book a Discovery Call</span>
              <span className="sm:hidden">Book Call</span>
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Layout;
